import { AuxRadioGroup } from "@blk/aladdin-react-components-es";
import React from "react";
import { useDispatch } from "react-redux";
import { useWidgetCurrentDataScale } from "components/widgets/hooks/use-current-widget";
import { language } from "language/default";
import { setCurrentStatusDataScale } from "store/current-dashboard";
import { DataScale } from "store/current-dashboard/types";
const { unit, million, billion, labelScale } = language.en.skeleton.settingsMenu.dataScale;
const dataRadioScale = (sectionId, widgetId) => [
    { disabled: false, eventData: DataScale.unit, label: unit, uid: `${sectionId}-${widgetId}-${DataScale.unit}` },
    { disabled: false, eventData: DataScale.million, label: million, uid: `${sectionId}-${widgetId}-${DataScale.million}` },
    { disabled: false, eventData: DataScale.billion, label: billion, uid: `${sectionId}-${widgetId}-${DataScale.billion}` }
];
export const InsSettingsScale = ({ widgetId, sectionId }) => {
    const dispatch = useDispatch();
    const currentScale = useWidgetCurrentDataScale(sectionId, widgetId);
    const onRadioGroupChanged = (event) => {
        dispatch(setCurrentStatusDataScale({ scale: event.detail.value.eventData, sectionId, widgetId }));
    };
    const data = dataRadioScale(sectionId, widgetId);
    data.forEach((e) => {
        e.checked = e.eventData === currentScale;
    });
    return React.createElement(AuxRadioGroup, { key: `${sectionId}-${widgetId}-${currentScale}`, data: data, label: labelScale, isStacked: true, onRadioGroupChanged: onRadioGroupChanged });
};
